/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamCohortStateResponse } from './oralExamCohortStateResponse';

export type GenericApiResponseOralExamCohortStateResponseData = OralExamCohortStateResponse | null;
